import React, { useEffect, useState } from 'react';

import GeneralRiskImpactsTableEditRow from './GeneralRiskImpactsTableEditRow';
import GeneralRiskImpactsTableRow from './GeneralRiskImpactsTableRow';

import Toast from 'CommonComponents/Toast';

export default function GeneralRiskImpactsTable(props) {
    const [impacts, setImpacts] = useState([]);
    const [editableImpact, setEditableImpact] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchGeneralRiskImpacts();
    }, []);

    const fetchGeneralRiskImpacts = () => {
        setIsLoading(true);
        axios
            .get(props.fetchUrl)
            .then(({ data }) => {
                setImpacts([...data]);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const prepareUpdateUrl = (impact) => {
        return props.updateUrl.replace('IMPACT_ID', impact.id);
    };

    return (
        <>
            <div className="inbud-table_wrapper">
                <table className="inbud-table">
                    <thead>
                        <tr>
                            <th className="tw-w-20">{$t('Ranking')}</th>
                            <th className="tw-w-40">{$t('Impact')}</th>
                            <th>{$t('Description')}</th>
                            <th className="tw-w-40">{$t('Actions')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!isLoading &&
                            !!impacts?.length &&
                            impacts.map((impact) => {
                                if (editableImpact && parseInt(editableImpact.id) === parseInt(impact.id)) {
                                    return (
                                        <GeneralRiskImpactsTableEditRow
                                            key={impact.id}
                                            impact={impact}
                                            onUpdated={fetchGeneralRiskImpacts}
                                            updateUrl={prepareUpdateUrl(impact)}
                                            onCancel={() => setEditableImpact(null)}
                                            onEdit={() => setEditableImpact(impact)}
                                        />
                                    );
                                } else {
                                    return <GeneralRiskImpactsTableRow key={impact.id} impact={impact} onEdit={() => setEditableImpact(impact)} />;
                                }
                            })}
                        {isLoading && (
                            <tr>
                                <td colSpan="100">{$t('Loading')}...</td>
                            </tr>
                        )}
                        {!isLoading && !impacts?.length && (
                            <tr>
                                <td colSpan="100">{$t('No Impacts found')}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Toast id="general-risk-impact-update-toast" message={$t('general risk impact updated successfully')} />
            <Toast id="general-risk-impact-update-failed-toast" message={$t('general risk impact update failed')} />
        </>
    );
}
